import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  Slider,
  InputNumber,
} from 'antd'
import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
import { updateActualGoalKpi } from 'api/Project/kpifinance'
import FormatMoney from 'common/FormatNumber/money'
import { Item } from 'gg-editor'
import { element, number, string } from 'prop-types'
import { getByDisplayValue } from '@testing-library/react'
import { CodeSandboxCircleFilled } from '@ant-design/icons'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}
let placeholder = ''
const UpdateKPI = (props) => {
  const {
    idEditPRJ,
    visableModalTaskGoals,
    setVisableModalTaskGoals,
    data,
    getResultKpi,
    subtaskId,
    getLogList,
    precision,
    setPrecision,
    taskLevel,
  } = props
  const language = getCookie('lang')
  const word = lang[language]
  const [checkGoal, setCheckGoal] = useState(false)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [isEnter, setIsEnter] = useState(false)
  const token = getCookie('access_token_admin')
  // const [visableModal, setVisableModal] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    setIsEnter(false)
    if (data.actual_goal === 0) {
      form.setFieldsValue({
        taskgoals: null,
      })
    } else {
      form.setFieldsValue({
        taskgoals: data.actual_goal,
      })
    }
  }, [visableModalTaskGoals])

  const onFinishTaskGoals = (values) => {
    if (!isEnter || !checkGoal) {
      const dataArray = {
        projectkpi_id: data.id,
        project_id: data.project_id,
        sprintflow_id: parseInt(subtaskId),
        actual_goal: values.taskgoals,
      }

      try {
        updateActualGoalKpi({
          params: dataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getResultKpi()
            getLogList()
          }
          setVisableModalTaskGoals(false)
          form.setFieldsValue({
            taskgoals: null,
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const showTitleModal = (data) => {
    if (data) {
      return <h2 className="Modaltitle no-breadcrumb">{data.name}</h2>
    } else {
      return <h2 className="Modaltitle no-breadcrumb">No Data</h2>
    }
  }

  const showTextGoal = (data) => {
    // console.log(data)
    const isSection = data?.section
    let onlyMin = data?.sprintflow_min
    let onlyMax = data?.sprintflow_max
    if ((isSection === 'of task' || isSection === 'of subtask') && taskLevel === 1) {
      onlyMin = data?.min
      onlyMax = data?.max
    }
    // const onlyMin = ['of task', 'of subtask'].includes(isSection)
    //   ? data?.min
    //   : data?.sprintflow_min
    // const onlyMax = ['of task', 'of subtask'].includes(isSection)
    //   ? data?.max
    //   : data?.sprintflow_max
    if (data.input_type_id === 22) {
      return (
        <h4 className="text-goal">
          Goal: {onlyMin} {data.unit_type_name} - {onlyMax} {data.unit_type_name}
          {/* Goal: {data?.sprintflow_min} {data.unit_type_name} - {data?.sprintflow_max}{' '} */}
          {/* {data.unit_type_name} */}
        </h4>
      )
    } else {
      let onlyGoal = data?.sprintflow_goal
      if ((isSection === 'of task' || isSection === 'of subtask') && taskLevel === 1) {
        onlyGoal = data?.goal
      }
      // console.log(onlyGoal)
      // const onlyGoal2 = ['of task', 'of subtask'].includes(isSection)
      //   ? data?.goal
      //   : data.sprintflow_goal
      // console.log(onlyGoal2)
      return (
        <h4 className="text-goal">
          {/* Goal: <FormatMoney num={data.sprintflow_goal} /> {data.unit_type_name} */}
          Goal: <FormatMoney num={onlyGoal} /> {data.unit_type_name}
        </h4>
      )
    }
  }
  const onChange = (value) => {
    // const onlyMin = data?.min ? data?.min : data?.sprintflow_min
    // const onlyMax = data?.max ? data?.max : data?.sprintflow_max
    // console.log(value)
    const isSection = data?.section
    let onlyMin = data?.sprintflow_min
    let onlyMax = data?.sprintflow_max
    if ((isSection === 'of task' || isSection === 'of subtask') && taskLevel === 1) {
      onlyMin = data?.min
      onlyMax = data?.max
    }
    // const onlyMin = ['of task', 'of subtask'].includes(isSection)
    //   ? data?.min
    //   : data?.sprintflow_min
    // const onlyMax = ['of task', 'of subtask'].includes(isSection)
    //   ? data?.max
    //   : data?.sprintflow_max

    if (data.input_type_id === 23) {
      if (typeof value === 'string') {
        setMsgErr('*Please enter a valid actual goals')
        setHiddenMsgErr(false)
        setCheckGoal(true)
      } else {
        setCheckGoal(false)
        setHiddenMsgErr(true)
      }
    } else {
      if (typeof value === 'string') {
        setMsgErr('*Please enter a valid min - max')
        setHiddenMsgErr(false)
        setCheckGoal(true)
      } else if (value > onlyMax || (value < onlyMin && value !== null)) {
        setMsgErr('*Please enter your actual goal between min to max')
        setHiddenMsgErr(false)
        setCheckGoal(true)
      } else {
        setHiddenMsgErr(true)
        setCheckGoal(false)
      }
    }
  }

  const onCancel = (e) => {
    form.setFieldsValue({
      taskgoals: null,
    })
    setPrecision(12)
    setCheckGoal(false)
    setVisableModalTaskGoals(false)
    setHiddenMsgErr(true)
  }
  const handleClearValue = () => {
    const dataArray = {
      projectkpi_id: data.id,
      project_id: data.project_id,
      sprintflow_id: parseInt(subtaskId),
      actual_goal: 0,
    }
    try {
      updateActualGoalKpi({
        params: dataArray,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getResultKpi()
          getLogList()
        }
        form.setFieldsValue({
          taskgoals: null,
        })
      })
    } catch (error) {
      console.log(error)
    }
    setVisableModalTaskGoals(false)
  }
  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      setIsEnter(true)
    } else {
      setIsEnter(false)
    }
  }
  const [msgErr, setMsgErr] = useState('Please enter a valid min - max')
  const [hiddenMsgErr, setHiddenMsgErr] = useState(true)
  return (
    <Modal
      maskClosable={false}
      title={showTitleModal(data)}
      visible={visableModalTaskGoals}
      // onOk={form.submit}
      onCancel={onCancel}
      // okText="Update"
      className="editmodal edit-modal-update-kpi responsive-modal-width"
      // okButtonProps={{ disabled: checkGoal }}
      destroyOnClose
      // cancelButtonProps={{ hidden: true }}
      footer={null}
    >
      <Form form={form} onFinish={onFinishTaskGoals} onKeyDown={handleKeyUp}>
        <Col span={24}>
          {/* {showTitleInput(data)} */}
          <h4 className="label">Task Goals ({data.unit_type_name})</h4>
          <Form.Item
            id="taskgoals"
            name="taskgoals"
            style={{ margin: 0 }}
            // rules={[
            //   {
            //     pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
            //     required: true,
            //     message: msgErr,
            //   },
            // ]}
            rules={[
              {
                validator: (rule, value, callback) => {
                  if (/^-?[0-9]{1,16}(\.[0-9]{1,2})?$/.test(value)) {
                    setCheckGoal(false);
                    callback();
                  } else {
                    setCheckGoal(true);
                    callback(word['Project_KPI/Finance_GoalMax']);
                  }
                },
              },
            ]}
          >
            <InputNumber
              type="number"
              id="taskgoal_input"
              name="taskgoal_input"
              // min={0}
              // maxLength={12}
              max={9999999999999999.99}
              // className="border"
              placeholder={'Task Goals' + ' ' + data.unit_type_name}
              size="large"
              style={{ width: '100%' }}
              // formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              // parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={onChange}
              step="0.00"
            />
          </Form.Item>
          <div>
            <div
              id="errorvalue"
              hidden={hiddenMsgErr}
              class="ant-form-item-explain ant-form-item-explain-error"
            >
              <div role="alert">{msgErr}</div>
            </div>
          </div>
          {showTextGoal(data)}
          <div style={{ marginTop: 12, justifyContent: 'flex-end', display: 'flex' }}>
            <Button className="BTN_Warning" onClick={handleClearValue}>
              Cancel value
            </Button>
            <Button
              className="BTN_Next"
              style={{ marginLeft: 8 }}
              onClick={form.submit}
              disabled={checkGoal}
            >
              Update
            </Button>
          </div>

          {/* <Slider defaultValue={30} /> */}
        </Col>
      </Form>
    </Modal>
  )
}
export default UpdateKPI
